export default __webpack_public_path__ + "static/media/icon-dostawa w godzinach.e68d4a54.svg";